import React from 'react'
import { Drawer, Typography, IconButton, Grid } from '@the-platform-group/component-library'
import { Close as CloseIcon } from '@the-platform-group/component-library/Icons'

const BaseJobDrawer = ({ open, onClose, title, children }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 600,
          p: 3,
          pt: 10,
          height: '100%',
          overflow: 'hidden',
          overflowY: 'auto',
        },
      }}
    >
      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
        <Grid item>
          <Typography variant="h6">{title}</Typography>
        </Grid>
        <Grid item>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      {children}
    </Drawer>
  )
}

export default BaseJobDrawer
